// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Np-z","tupacHeader":"Op-z","tupacHeader2":"Pp-z","tupacMenu":"Qp-z","tupacMenu2":"Rp-z","tupacMain":"Sp-z","tupacMain2":"Tp-z"};